import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { menuApi } from "../utils/menuApi";

const VariantGroupDialog = ({
  open, mode, data, token, clientId, locationId, foodType, category, item, onClose, onSuccess, showSnackbar,
}) => {
  const [form, setForm] = useState({ name: "", display_order: 1 });

  useEffect(() => {
    if (data) {
      setForm({
        name: data.name || "",
        display_order: data.display_order ?? 1,
      });
    } else {
      setForm({ name: "", display_order: 1 });
    }
  }, [data, open]);

  const handleSave = async () => {
    const payload = { ...form, display_order: Number(form.display_order || 1) };

    try {
      if (mode === "edit" && data?.id) {
        await menuApi.updateVariantGroup({
          token,
          clientId,
          locationId,
          foodTypeId: foodType.id,
          categoryId: category.id,
          itemId: item.id,
          variantGroupId: data.id,
          payload,
        });
        showSnackbar("Variant group updated successfully");
      } else {
        await menuApi.createVariantGroup({
          token,
          clientId,
          locationId,
          foodTypeId: foodType.id,
          categoryId: category.id,
          itemId: item.id,
          payload,
        });
        showSnackbar("Variant group created successfully");
      }
      onSuccess();
      onClose();
    } catch (error) {
      showSnackbar(error?.response?.data?.detail || "Failed to save variant group", "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{mode === "edit" ? "Edit Variant Group" : "Add Variant Group"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}><TextField fullWidth label="Name" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} /></Grid>
          <Grid item xs={12}><TextField fullWidth type="number" label="Display Order" value={form.display_order} onChange={(e) => setForm((p) => ({ ...p, display_order: e.target.value }))} /></Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default VariantGroupDialog;